var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointLogo28X28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 14a7.584 7.584 0 1 0-15.168.002A7.584 7.584 0 0 0 28.001 14Z",
  fill: "#2E87FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.525 13.976h1.418c.338 0 .618-.117.841-.352.223-.234.334-.525.334-.87 0-.347-.11-.645-.334-.877a1.122 1.122 0 0 0-.841-.346h-1.418v2.445Zm-1.591-3.436c0-.273.221-.494.494-.494h2.513c.77 0 1.421.26 1.96.784.53.523.794 1.163.794 1.925 0 .761-.265 1.403-.794 1.924-.539.522-1.19.784-1.96.784h-1.418v1.78a.795.795 0 1 1-1.59 0V10.54Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2 7H2.818A2.818 2.818 0 0 0 0 9.818v8.363A2.819 2.819 0 0 0 2.818 21h8.363A2.82 2.82 0 0 0 14 18.181v-8.38A2.8 2.8 0 0 0 11.2 7Z",
  fill: "#1A2E82"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.046 18.116a.909.909 0 1 1-1.818 0 .909.909 0 0 1 1.818 0Z",
  fill: "#2D91FF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.944 14.919c-.298 0-.592.193-.748.39-.472.545-1.101.974-1.928.974a2.274 2.274 0 0 1-2.284-2.26c0-1.21.984-2.262 2.284-2.262.827 0 1.456.43 1.928.975.156.196.454.39.748.39.546 0 .919-.411.919-.865a.954.954 0 0 0-.15-.54c-.744-1.094-1.943-1.793-3.445-1.793-2.322 0-4.133 1.793-4.133 4.093s1.811 4.093 4.133 4.093c1.496 0 2.701-.699 3.444-1.794a.937.937 0 0 0 .151-.539c0-.45-.376-.865-.919-.865",
  fill: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.046 18.116a.909.909 0 1 1-1.818 0 .909.909 0 0 1 1.818 0Z",
  fill: "#2D91FF"
})));
export default SvgPointLogo28X28;